import { render, staticRenderFns } from "./RemplacementAlerts.vue?vue&type=template&id=5fb3720a"
import script from "./RemplacementAlerts.vue?vue&type=script&lang=ts"
export * from "./RemplacementAlerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports